import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import * as Icon from "@phosphor-icons/react";
import Layout from "../Home/layout.jsx";

import { DataHelper } from "../../Common/Helpers/data-helper.js";

import styles from "./student.css"
import "./../../../Styles/site.css"

function Index() {
    const [ossConfig, setOssConfig] = useState({ ossDomain: "" });
    const [schoolCode, setSchoolCode] = useState("");
    const [registrations, setRegistrations] = useState([]);

    useEffect(getOssConfig, []);

    function getOssConfig() {
        DataHelper.getOssConfig(function (ossConfig) {
            setOssConfig({
                ossDomain: ossConfig.ossDomain
            });

            getSchoolCode(ossConfig.ossDomain);
        });
    }

    function getSchoolCode(ossDomain) {
        DataHelper.getSchoolCode(function (schoolCode) {
            setSchoolCode(schoolCode);

            getUserId(ossDomain, schoolCode);
        });
    }

    function getUserId(ossDomain, schoolCode) {
        DataHelper.getUserId(function (userId) {
            getRegistrationRecords(userId, ossDomain, schoolCode);
        });
    }

    function getRegistrationRecords(userId, ossDomain, schoolCode) {
        $.ajax({
            url: "/enrollment/getuserregistrations?userId=" + userId,
            method: "GET",
            contentType: "application/json; charset=utf-8",
        })
            .done((response, textStatus, xhr) => {
                if (textStatus === "success") {
                    const regIds = [];
                    response.forEach(function (reg) {
                        regIds.push(reg.ossRegId);
                    });

                    if (ossDomain !== "")
                        loadRegistrations(regIds, ossDomain, schoolCode);
                }
            })
            .fail((xhr, textStatus, errorThrown) => {
                console.log(errorThrown);
            });
    }

    function loadRegistrations(regIds, ossDomain, schoolCode) {
        const registrationIds = regIds.join();

        if (registrationIds.trim() !== "") {
            $.ajax({
                url: ossDomain + "/api/registrations/byids?registrationIds=" + registrationIds + "&activeOnly=true",
                method: "GET",
                contentType: "application/json; charset=utf-8",
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("Authorization", "Bearer " + DataHelper.getOssApiToken());
                    xhr.setRequestHeader("SchoolCode", schoolCode);
                }
            })
                .done((response, textStatus, xhr) => {
                    if (textStatus === "success") {
                        let regs = [];
                        response.forEach(function (reg) {
                            regs.push({
                                id: reg.id,
                                schoolYearTerm: reg.term.schoolYearTermName,
                                level: reg.level.name,
                                status: reg.status.name,
                                dateOfRegistration: reg.dateOfRegistration,
                                student: reg.student.fullNameInFnMiLn
                            });
                        });

                        setRegistrations(regs);
                    }
                })
                .fail((xhr, textStatus, errorThrown) => {
                    console.log(errorThrown);
                });
        }
    }

    return (
        <Layout title="Student Account">
            <div styleName="layout">
                {/* Actions */}
                <div styleName="section__actions">
                    <span styleName="main-form-container-section__header"><Icon.Cursor weight="fill" styleName="icon" /> Actions to Perform</span>
                    <div styleName="action" onClick={() => window.location = "/student/ledger"}>
                        <div styleName="table-child-action-link" ><Icon.FileText weight="fill" styleName="action-icon" />  View Student Ledger</div>
                    </div>
                    <div styleName="action" onClick={() => window.location = "/student/statementofaccount"}>
                        <div styleName="table-child-action-link" ><Icon.ListBullets weight="fill" styleName="action-icon" /> View Statement of Account</div>
                    </div>
                </div>

                {/* Other Info */}
                <div styleName="section__other-info">
                    <span styleName="main-form-container-section__header"><Icon.PlusCircle weight="fill" styleName="icon" /> Other Info</span>
                    <div styleName="action" onClick={() => window.location = "/student/proofofpayments"}>
                        <div styleName="table-child-action-link" ><Icon.CreditCard weight="fill" styleName="action-icon" /> List of Proof of Payments</div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

ReactDOM.render(
    <Index />,
    document.getElementById("root")
);